import {
  Column1,
  ContentContainerRight,
  DataTitle,
  Row5,
} from "pages/home/components/Layout";

// 답변 상태 + 날짜 섹션 컴포넌트
export const InquiriesInfo = ({ slicedData }) => {
  return (
    <ContentContainerRight>
      <Column1>
        {slicedData.map((data) => (
          <ContentContainerRight
            key={`inquiry_info_${data.__source}_${data.id ?? data.createdAt ?? data.title}`}
            $height={22}
            $bottom={10}
          >
            <Row5>
              {/* 답변 상태 */}
              {data.status === 0 ? (
                <DataTitle $color="red">답변 대기</DataTitle>
              ) : data.status === 1 ? (
                <DataTitle $color="black">진행 중</DataTitle>
              ) : (
                <DataTitle $color="black">답변 완료</DataTitle>
              )}

              {/* 날짜 */}
              <DataTitle>{data.createdAt}</DataTitle>
            </Row5>
          </ContentContainerRight>
        ))}
      </Column1>
    </ContentContainerRight>
  );
};
